import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import RippleButton from "../../../components/common/RippleButton";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { LoadingPanel } from "../../../components/layout/Loading";
import {
  createTourItineraryArray,
  getTourItineraryByID,
} from "../services/tour.services";
import {
  clearTourItineraryDetails,
  decreaseActiveStep,
  increaseActiveStep,
} from "../tourSlice";
import { closeDialog } from "../../../components/dialog/dialogSlice";
import { getAllActiveHotels } from "../../hotel/services/hotel.services";
import ShadowCard from "../../../components/common/ShadowCard";
import TourItineraryArray from "./TourItineraryArray";
import { getAllActiveItinerary } from "../../itinerary/services/itineary.services";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { getCityBySectorID } from "../../city/services/city.services";
import { getAllActiveItineraryFacility } from "../../ItineraryFacility/services/itineraryfacility.services";
import { RootState } from "../../../app/store";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const TourItineararyChangeWatcher: React.FC<FormChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const TourItineraryDetails = useAppSelector(
    (state: RootState) => state.tour.TourItineraryDetails
  );

  useEffect(() => {
    const tourItineraryCopy = JSON.parse(
      JSON.stringify(TourItineraryDetails)
    )?.map((tourItinerary: any) => ({
      ...tourItinerary,
    }));
    formRenderProps.onChange("TourItinerary", {
      value: tourItineraryCopy || [],
    });
  }, [TourItineraryDetails]);
  return null;
};
const TourItinerary: React.FC = () => {
  const location = useLocation();
  const TourID = location.state?.TourID;
  const SectorID = location.state?.SectorID;
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.tour.loading);
  const TourItineraryDetails = useAppSelector(
    (state) => state.tour.TourItineraryDetails
  );

  useEffect(() => {
    dispatch(getAllActiveHotels());
    dispatch(getAllActiveItinerary());
    dispatch(getAllActiveItineraryFacility());
    if (TourID) {
      dispatch(getTourItineraryByID(TourID));
    }
    if (SectorID) {
      dispatch(getCityBySectorID(SectorID));
    }
    return () => {
      dispatch(closeDialog());
      dispatch(clearTourItineraryDetails());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    if (TourID) {
      const insertPayload = {
        ItinerariesData: values.TourItinerary
          ? values.TourItinerary.map((touritinerary: any) => {
              return {
                DayNo: touritinerary.DayNo ? touritinerary.DayNo : null,
                TourID: TourID,
                ItineraryID: touritinerary.ItineraryID
                  ? touritinerary.ItineraryID
                  : null,
                ItineraryDescription: touritinerary.ItineraryDescription
                  ? touritinerary.ItineraryDescription
                  : "",
                CityID: touritinerary.CityID ? touritinerary.CityID : null,
                HotelID: touritinerary.HotelID ? touritinerary.HotelID : null,
                ItineraryFacilityID: Array.isArray(
                  touritinerary.ItineraryFacilityID
                )
                  ? touritinerary.ItineraryFacilityID.join(",")
                  : touritinerary.ItineraryFacilityID,
              };
            })
          : [],
      };
      const response = await dispatch(createTourItineraryArray(insertPayload));
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(increaseActiveStep());
      }
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <Form
        onSubmit={handleSubmit}
        initialValues={TourItineraryDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <TourItineararyChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem style={{ marginTop: 10 }} colSpan={3}>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={TourItineraryArray}
                    name="TourItinerary"
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <RippleButton
                    type="button"
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginRight: 10 }}
                    onClick={() => dispatch(decreaseActiveStep())}
                  >
                    Previous
                  </RippleButton>
                  {/* {isWebsite === "YES" ? ( */}
                  <ButtonWithLoading
                    label={"Save & Next"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  {/* ) : (
                    <>
                      <ButtonWithLoading
                        label={"Save & Go to Tour List"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />

                      <RippleButton
                        fillMode="solid"
                        themeColor="primary"
                        style={{ marginLeft: 10 }}
                        onClick={() => navigate("/tour")}
                      >
                        Go to Tour List
                      </RippleButton>
                    </>
                  )} */}
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};
export default TourItinerary;
